"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableRow = exports.ExpandedRow = void 0;
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var globalVars_module_scss_1 = __importDefault(require("../../globalVars.module.scss"));
var Common_1 = require("../Common");
var TableColumn_1 = require("./TableColumn");
var Row = styled_components_1.default.tr.attrs({
    className: 'tws-table-row',
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t&.tws-table-row td {\n\t\t", "\n\t}\n\t", "\n\t&.tws-table-row.tws-table-row-selected td:not(:first-child) {\n\t\tbackground-color: ", ";\n\t\tcolor: ", ";\n\t}\n\t&.tws-table-row.tws-table-row-selected td:not(:first-child) a {\n\t\tcolor: ", ";\n\t}\n\t&.tws-table-row.tws-table-row-selected.tws-table-row td:nth-child(2) {\n\t\tborder-left: ", " ", " ", " !important;\n\t}\n"], ["\n\t&.tws-table-row td {\n\t\t", "\n\t}\n\t", "\n\t&.tws-table-row.tws-table-row-selected td:not(:first-child) {\n\t\tbackground-color: ", ";\n\t\tcolor: ", ";\n\t}\n\t&.tws-table-row.tws-table-row-selected td:not(:first-child) a {\n\t\tcolor: ", ";\n\t}\n\t&.tws-table-row.tws-table-row-selected.tws-table-row td:nth-child(2) {\n\t\tborder-left: ", " ", " ", " !important;\n\t}\n"])), function (props) { return (props.expanded ? 'background-color: #dfebef;' : ''); }, function (props) {
    return props.selectable &&
        "&.tws-table-row td:first-child {\n\t\t.tws-input-checkbox-wrapper {\n\t\t\tmargin-top: -10px;\n\t\t\tlabel {\n\t\t\t\tdisplay: block;\n\t\t\t}\n\t\t}\n\t}";
}, globalVars_module_scss_1.default.mainBlue, globalVars_module_scss_1.default.white, globalVars_module_scss_1.default.white, globalVars_module_scss_1.default.spacing10, globalVars_module_scss_1.default.borderSolid, globalVars_module_scss_1.default.mainBlue);
Row.displayName = 'Row';
exports.ExpandedRow = styled_components_1.default.tr.attrs({
    className: 'tws-table-row-drawer',
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\t&.tws-table-row-drawer {\n\t\tbackground-color: ", ";\n\t}\n\t&.tws-table-row-drawer > td .table tr.tws-table-head-row {\n\t\tbackground-color: unset;\n\t}\n\t&.tws-table-row-drawer td .tws-table-row-drawer-container {\n\t\tmargin: 10px 0 20px 0;\n\t}\n\t&.tws-table-row-drawer > td {\n\t\tborder-top: 0;\n\t\tbackground-color: ", ";\n\t}\n\t&.tws-table-row-drawer > td:first-child {\n\t\tborder-left: 0;\n\t\tpadding: 0;\n\t}\n\t&.tws-table-row-drawer > td:last-child {\n\t\tpadding-right: 0 !important;\n\t}\n\t&.tws-table-row-drawer > td > div > div {\n\t\tpadding-right: 10px;\n\t\tpadding-left: 10px;\n\t}\n\t&.tws-table-row-drawer > td .table {\n\t\tborder-collapse: separate;\n\t\tmargin-top: -10px;\n\t\tmargin-bottom: -10px !important;\n\t}\n\t&.tws-table-row-drawer > td .table td {\n\t\tbackground-color: #f6f6f6;\n\t}\n\t", "\n"], ["\n\t&.tws-table-row-drawer {\n\t\tbackground-color: ", ";\n\t}\n\t&.tws-table-row-drawer > td .table tr.tws-table-head-row {\n\t\tbackground-color: unset;\n\t}\n\t&.tws-table-row-drawer td .tws-table-row-drawer-container {\n\t\tmargin: 10px 0 20px 0;\n\t}\n\t&.tws-table-row-drawer > td {\n\t\tborder-top: 0;\n\t\tbackground-color: ", ";\n\t}\n\t&.tws-table-row-drawer > td:first-child {\n\t\tborder-left: 0;\n\t\tpadding: 0;\n\t}\n\t&.tws-table-row-drawer > td:last-child {\n\t\tpadding-right: 0 !important;\n\t}\n\t&.tws-table-row-drawer > td > div > div {\n\t\tpadding-right: 10px;\n\t\tpadding-left: 10px;\n\t}\n\t&.tws-table-row-drawer > td .table {\n\t\tborder-collapse: separate;\n\t\tmargin-top: -10px;\n\t\tmargin-bottom: -10px !important;\n\t}\n\t&.tws-table-row-drawer > td .table td {\n\t\tbackground-color: #f6f6f6;\n\t}\n\t", "\n"])), globalVars_module_scss_1.default.white, globalVars_module_scss_1.default.white, function (props) {
    return props.selectable
        ? "&.tws-table-row-drawer > td .table tr.tws-table-row td:nth-child(2) {\n\t\tborder-left: ".concat(globalVars_module_scss_1.default.spacing10, " ").concat(globalVars_module_scss_1.default.borderSolid, " ").concat(globalVars_module_scss_1.default.white, ";\n\t}")
        : props.expandedRowShowLeftBorder
            ? ''
            : "&.tws-table-row-drawer > td .table tr.tws-table-row td:first-child {\n\t\tborder-left: 0;\n\t}";
});
exports.ExpandedRow.displayName = 'ExpandedRow';
var TableRow = /** @class */ (function (_super) {
    __extends(TableRow, _super);
    function TableRow(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            selected: _this.props.selected,
        };
        _this.toggleSelectRow = _this.toggleSelectRow.bind(_this);
        return _this;
    }
    // this is a react ANTI-Pattern.  We do not need to use state and should just render the props.
    TableRow.getDerivedStateFromProps = function (props) {
        return { selected: props.selected || false };
    };
    TableRow.prototype.render = function () {
        var _a = this.props, children = _a.children, record = _a.record, selectable = _a.selectable, disabled = _a.disabled;
        var selected = this.state.selected;
        var className = selected ? 'tws-table-row-selected' : '';
        return (React.createElement(React.Fragment, null,
            React.createElement(Row, __assign({ className: className, selected: selected }, this.props),
                selectable && (React.createElement(TableColumn_1.TableColumn, null,
                    React.createElement(Common_1.Checkbox, { label: '', disabled: disabled, checked: selected, onChange: this.toggleSelectRow }))),
                children),
            this.renderExpandRow(record)));
    };
    TableRow.prototype.renderExpandRow = function (record) {
        var _a = this.props, expanded = _a.expanded, expandedRowRender = _a.expandedRowRender;
        if (expandedRowRender) {
            return expanded && React.createElement(exports.ExpandedRow, __assign({}, this.props), expandedRowRender(record));
        }
        return null;
    };
    TableRow.prototype.toggleSelectRow = function () {
        this.setState({ selected: !this.state.selected });
        var _a = this.props, onSelectRow = _a.onSelectRow, record = _a.record;
        if (onSelectRow) {
            onSelectRow(record && record.key);
        }
    };
    return TableRow;
}(React.Component));
exports.TableRow = TableRow;
var templateObject_1, templateObject_2;
